import styled from 'styled-components'
import { SizeProps, SpaceProps, size, space } from 'styled-system'

interface Props extends SpaceProps, SizeProps {}

export const CleanLink = styled.a<Props>`
  ${size};
  ${space}
  background: none;
  outline: 0;
  border: 0;
`

CleanLink.defaultProps = {
  m: 0,
}
